/**
 * Created by mestrad on 2018. 06. 28..
 */

import PageParameters from './PageParameters';

var Common = {
    getUrlParam: function getUrlParam(name, url) {
        url = url || location.search;
        if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(url))
            return decodeURIComponent( name[ 1 ].replace( /\+/g, '%20' ) );

        return PageParameters.getParam(name);
    },
    getCurrentDate: function() {
        var date = new Date();
        var mm = date.getMonth() + 1;
        var dd = date.getDate();

        return [date.getFullYear(),
            '-',
            (mm>9 ? '' : '0') + mm,
            '-',
            (dd>9 ? '' : '0') + dd
        ].join('');
    },

    isJsonString: str => {
        try {
            JSON.parse( str );
        } catch ( e ) {
            return false;
        }
        return true;
    }
};

export default Common;